module.exports = __webpack_public_path__ + "img/86ccf5d.png";